import { cva } from "../../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.js";
import { cn } from "../../../lib/utils.js";
const size = {
  sm: "h-6 px-1 text-sm",
  default: "px-2 h-9 text-base",
  lg: "h-10 px-2 text-lg"
}, inputBasicClassNames = "flex w-full min-w-0 py-1 border transition-[background-color,border-color,color,box-shadow]", inputVariants = cva(
  cn`
    ${inputBasicClassNames}
    text-(--gray-text-2) outline-none placeholder:text-(--gray-primary-1-alpha) border-input
    selection:bg-primary selection:text-primary-foreground
    disabled:bg-(--gray-tag-1-alpha) disabled:pointer-events-none disabled:cursor-not-allowed
    focus-visible:border-(--border-3-alpha) focus-visible:ring-(--border-1-alpha) focus-visible:border-ring focus-visible:ring-[1px]
    focus:border-(--border-3-alpha) focus:ring-(--border-1-alpha) focus:border-ring focus:ring-[1px]
    aria-invalid:border-(--red-6-alpha) aria-invalid:focus-visible:ring-(--red-3-alpha) aria-invalid:focus:ring-(--red-3-alpha)
  `,
  {
    variants: {
      variant: {
        default: "bg-(--white) border-(--gray-tag-3-alpha)",
        filled: cn`
          bg-(--tag-1-alpha) border-transparent focus-visible:not([readonly]):bg-(--tag-3-alpha)
          focus:not([readonly]):bg-(--tag-3-alpha) aria-invalid:bg-(--red-3-alpha)
        `
      },
      size,
      isSelectInput: {
        default: "read-only:bg-(--gray-tag-1-alpha)",
        isSelectInput: ""
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default",
      isSelectInput: "default"
    }
  }
), inputRoundedVariants = cva(null, {
  variants: {
    roundedLeft: {
      default: "rounded-l-md",
      none: ""
    },
    roundedRight: {
      default: "rounded-r-md",
      none: ""
    }
  }
}), inputGroupVariants = cva(
  cn`
    ${inputBasicClassNames}
    has-[input:disabled]:bg-(--gray-tag-1-alpha) has-[input:disabled]:pointer-events-none has-[input:disabled]:cursor-not-allowed
    has-[input[aria-invalid=true]]:border-(--red-6-alpha)
    has-[input:focus-visible]:border-(--border-3-alpha) has-[input:focus-visible]:ring-(--border-1-alpha) has-[input:focus-visible]:border-ring
    has-[input:focus-visible]:ring-[1px]
    has-[input:focus]:border-(--border-3-alpha) has-[input:focus]:ring-(--border-1-alpha) has-[input:focus]:border-ring
    has-[input:focus]:ring-[1px]    
    has-[input[aria-invalid=true]:focus]:ring-(--red-3-alpha)
  `,
  {
    variants: {
      variant: {
        default: "bg-(--white) border-(--gray-tag-3-alpha)",
        filled: cn`
          bg-(--tag-1-alpha) border-transparent
          has-[input:focus-visible]:bg-(--tag-3-alpha) has-[input:focus]:bg-(--tag-3-alpha)
          has-[input[aria-invalid=true]]:bg-(--red-3-alpha) has-[input[aria-invalid=true]]:ring-(--red-3-alpha)
        `
      },
      size,
      isSelectInput: {
        default: "has-[input:read-only]:bg-(--gray-tag-1-alpha)",
        isSelectInput: ""
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default",
      isSelectInput: "default"
    }
  }
), inputGroupGapVariants = cva(
  "flex items-center",
  {
    variants: {
      size: {
        sm: "gap-1",
        default: "gap-2",
        lg: "gap-2"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
), inputGroupInputVariants = cva(
  "w-full bg-transparent outline-none selection:bg-primary selection:text-primary-foreground"
), inputAddAndFixTextVariants = cva(null, {
  variants: {
    invalid: {
      default: "text-(--gray-text-2)",
      invalid: "text-(--red-9)"
    }
  },
  defaultVariants: {
    invalid: "default"
  }
}), inputTextVariants = cva(null, {
  variants: {
    size: {
      sm: "text-sm",
      default: "text-base",
      lg: "text-lg"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), inputAddonVariants = cva(
  "content-center",
  {
    variants: {
      variant: {
        default: "border-t border-b bg-(--white)",
        filled: ""
      },
      size: {
        sm: "px-1 h-6",
        default: "px-2 h-9",
        lg: "px-2 h-10"
      },
      rounded: {
        before: "rounded-l-md",
        after: "rounded-r-md"
      },
      border: {
        before: "",
        after: ""
      },
      invalid: {
        default: "border-(--gray-tag-3-alpha)",
        invalid: "border-(--red-6-alpha)"
      }
    },
    compoundVariants: [
      {
        border: "before",
        variant: "default",
        class: "border-l"
      },
      {
        border: "after",
        variant: "default",
        class: "border-r"
      },
      {
        invalid: "default",
        variant: "filled",
        class: "border-transparent bg-(--tag-1-alpha)"
      },
      {
        invalid: "invalid",
        variant: "filled",
        class: "border-t border-b bg-(--red-3-alpha)"
      },
      {
        invalid: "invalid",
        variant: "filled",
        border: "before",
        class: "border-l"
      },
      {
        invalid: "invalid",
        variant: "filled",
        border: "after",
        class: "border-r"
      }
    ],
    defaultVariants: {
      variant: "default",
      size: "default",
      invalid: "default"
    }
  }
);
export {
  inputAddAndFixTextVariants,
  inputAddonVariants,
  inputGroupGapVariants,
  inputGroupInputVariants,
  inputGroupVariants,
  inputRoundedVariants,
  inputTextVariants,
  inputVariants
};
//# sourceMappingURL=variants.js.map
